
import axiosinstances from "../Helper/useAxios";


async function Transactionhistoryapicall({page,clientId,isAdmin,agentId}) {
  const [axiosInstance] = axiosinstances()
  //console.log('TRANSACTION_HISTORY')
  const d=sessionStorage.getItem('token') && JSON.parse(sessionStorage.getItem('token')).token ? JSON.parse(sessionStorage.getItem('token')).token : "";
  const e=JSON.parse(sessionStorage.getItem('token'))
  const response = await axiosInstance
  .post(`/api/v1/billpay/order/history`,  {
    "header" : {
        "client-id":clientId,
        "role":"ROLE_RETAILER_FINXPAY"
    },
    "device" : null,
    "agentId" : isAdmin ? agentId :clientId,
    "pageNo" : page,
    "startDate" : "",
    "endDate" : "",
    "status" : "ACCEPTED"
  },
  { headers: { "Authorization": `Bearer ${e}`, "client-id": clientId, "role": "ROLE_RETAILER_FINXPAY" } })
 .then((res) => {
   //console.log('res11111111', res)
   return res
 })
 .catch((err) => {
   //console.log(err);
 });
  // const response = await axios
  //       .post(
  //   "http://qa.finxpay.co.in/api/v1/billpay/order/history",
  //   {
  //     "header" : {
  //         "client-id":id,
  //         "role":"ROLE_RETAILER_FINXPAY"
  //     },
  //     "device" : null,
  //     "agentId" : id,
  //     "pageNo" : 0,
  //     "startDate" : "",
  //     "endDate" : "",
  //     "status" : "ACCEPTED"
  //   },
  //   { headers: { "Authorization": `Bearer ${e}`, "client-id": id, "role": "ROLE_RETAILER_FINXPAY" } }
  //   );
 
    if (response) {

      const result = response.data;

      if (result) {
      }

      return response.data;
  }
  return false;
}
export default Transactionhistoryapicall;
